import { ref } from "vue";
import axios from "axios";
import authHeader from "@/Api/AuthHeader";


export default {

  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async addEvent(data) {

        
        try { 
            const resp = await axios.post('/api/purpose', data, {headers:authHeader()});
            return resp;
        } catch (error) {
            return error;
        }
    },

    async getAllPurpose(page){
        try {
            const resp = await axios.get('/api/purpose?page='+page, {headers:authHeader()});

            return resp;
        } catch (error) {
            return error;
        }
    },

    async getLastPurposeInserted(){
        try {
            const resp = await axios.get("/api/getLastPurposeInserted", {headers:authHeader()});

            return resp;
        } catch (error) {
            return error;
        }
    },

    async getCategories(){
        try {
            const resp = await axios.get(`/api/categories`, {headers:authHeader()});

            return resp;
        } catch (error) {
            return error;
        }
    },

    async getGroups(){
        try {
            const resp = await axios.get(`/api/group`, {headers:authHeader()});

            return resp;
        } catch (error) {
            return error;
        }
    },

    async findPurpose(id){
        try {
            const resp = await axios.get(`/api/purpose/${id}`, {headers:authHeader()});

            return resp;
        } catch (error) {
            return error;
        }
    },

    async updateGroup(data, id){ 

        try {

            let dat = new FormData();


            dat.append("title",data.title)
            dat.append("description",data.description)
            dat.append("id",id)


            const resp = await axios.post(`/api/updateGroup`, dat, {headers:authHeader()});
            return resp;
        } catch (error) {
            return error;
        }
    },

    async getMyProduct(user_id){

        try {
            const resp = await axios.get(`/api/getMyProduct/${user_id}`, {headers:authHeader()});
            return resp;
        } catch (error) {
            return error;
        }

    },
 

    async removeProduct(id){
        try {
            const resp = await axios.get(`/Api/api/removeProduct?product_id=${id}`, {headers:authHeader()});
            return resp;
        } catch (error) {
            return error;
        }
    },
 
 

}

}